import { render, staticRenderFns } from "./TrainingRegDetails.vue?vue&type=template&id=040daffe&scoped=true&"
import script from "./TrainingRegDetails.vue?vue&type=script&lang=js&"
export * from "./TrainingRegDetails.vue?vue&type=script&lang=js&"
import style0 from "./TrainingRegDetails.vue?vue&type=style&index=0&id=040daffe&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040daffe",
  null
  
)

export default component.exports